import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import data from "../../json/index.json";

const Blog = () => {
  return (
    <div className="blog_categories flex-center">
      <div className="blog_categories_main container">
        <h1 className="dc-script text-center">Latest Blog</h1>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 2500, disableOnInteraction: true }}
          loop={true}
          spaceBetween={50}
          slidesPerView={1}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          className="blog_slide_wrapper"
        >
          {data.blogs.map((item) => (
            <SwiperSlide className="blog_slide" key={item.id}>
              <div className="blog_content bg-white dm-sans">
                <img src="/img/blog/blog-1.webp" alt="blog" />
                <div className="blog_content_details">
                  <div className="blog_heading d-flex align-items-center gap-2">
                    <span></span>
                    <h4>{item.name}</h4>
                  </div>
                  <h3>{item.heading}</h3>
                  <span>
                    {item.date} - By {item.by}
                  </span>
                  <p>{item.description}</p>
                  <button>
                    <a href="/">Read more</a>
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Blog;
